import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import API from "../api/api";

export default function Login({ onLogin }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      setError("");

      const res = await API.post("/auth/login", {
        email,
        password
      });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      onLogin(res.data.user);
      navigate("/dashboard");

    } catch (err) {
      setError("Aanmelden mislukt");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2 className="login-title">Admin aanmelden</h2>
        <p className="login-copy">Meld je aan om reservaties, trailers en waarborgen te beheren.</p>

        <input
          className="input"
          placeholder="E-mail"
          onChange={(e) => setEmail(e.target.value)}
        />

        <div style={{ height: 12 }} />

        <input
          className="input"
          type="password"
          placeholder="Wachtwoord"
          onChange={(e) => setPassword(e.target.value)}
        />

        {error && <p className="error-text">{error}</p>}

        <div style={{ height: 16 }} />

        <button className="button" style={{ width: "100%" }} onClick={handleLogin}>
          Aanmelden
        </button>

        <Link className="button secondary login-home-link" to="/">
          Terug naar homepagina
        </Link>
      </div>
    </div>
  );
}
